import {
  DATA_CONNECTOR_XATA_WORKSPACE_LIST_BEGIN,
  DATA_CONNECTOR_XATA_WORKSPACE_LIST_SUCCESS,
  DATA_CONNECTOR_XATA_WORKSPACE_LIST_FAILURE,
  DATA_CONNECTOR_XATA_WORKSPACE_LIST_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function xataWorkspaceList(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_XATA_WORKSPACE_LIST_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xata/data-sources`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_XATA_WORKSPACE_LIST_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_XATA_WORKSPACE_LIST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissXataWorkspaceListError() {
  return {
    type: DATA_CONNECTOR_XATA_WORKSPACE_LIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_XATA_WORKSPACE_LIST_BEGIN:
      return {
        ...state,
        xataWorkspaceListPending: true,
        xataWorkspaceListError: null,
      };

    case DATA_CONNECTOR_XATA_WORKSPACE_LIST_SUCCESS:
      return {
        ...state,
        xataWorkspaceListPending: false,
        xataWorkspaceListError: null,
        workSpaceByXata: action.data,
      };

    case DATA_CONNECTOR_XATA_WORKSPACE_LIST_FAILURE:
      return {
        ...state,
        xataWorkspaceListPending: false,
        xataWorkspaceListError: action.data.error,
      };

    case DATA_CONNECTOR_XATA_WORKSPACE_LIST_DISMISS_ERROR:
      return {
        ...state,
        xataWorkspaceListError: null,
      };

    default:
      return state;
  }
}
